<template>
    <b-container class="p-2 customer-feedback bg-whitesmoke">
        <div class="page--title">
            <a
                    href="javascript: history.go(-1)"
                    class="return--btn"
            >
                <i class="fas fa-arrow-left"></i>
            </a>
            <h1>
                <i class="fas fa-comment-alt"></i>
                Support client
            </h1>
        </div>

        <div class="customer-feedback-info mb-3">
            <div class="d-inline-flex">
                <i class="fas fa-info-circle mr-1"></i>
                <p class="m-0">Communiquez-nous vos avis et suggestions sur l'application Alter Ego Digital</p>
            </div>
        </div>
        <b-form @submit.prevent="submit" class="form--style">
            <b-form-group class="font-weight-bold" label="Sélectionnez le sujet concerné">
                <b-form-select class="form--select" v-model="form.typeId" :options="types" required/>
            </b-form-group>
            <b-form-group class="font-weight-bold" label="Description">
                <b-form-textarea
                        v-model="form.content"
                        class="form--textarea"
                        placeholder="Précisez votre demande ou avis ici ..."
                        rows="4"
                        required
                />
                <b-btn class="btn--dark mt-3" block type="submit">
                    <i class="fas fa-paper-plane mr-1"></i>
                    Envoyer
                </b-btn>
            </b-form-group>
        </b-form>
    </b-container>
</template>

<script>
    import basicErrorHandler from '@/utils/handlers/basicErrorHandler'
    import swal from 'sweetalert'

    export default {
        name: 'support',
        async mounted() {
            try {
                const {status} = await this.$store.dispatch('base/feedback/settings')
            } catch (e) {
                basicErrorHandler(e)
            }
        },
        data: () => ({
            form: {
                typeId: null,
                content: null
            }
        }),
        watch: {
            types(values) {
                if (values.length === 0) return
                this.form.typeId = values[0].value
            }
        },
        computed: {
            settings() {
                return this.$store.state.base.feedback.settings
            },
            types() {
                const {formTypes} = this.settings
                if (formTypes === undefined) return []
                return formTypes.map(({id, name}) => ({value: id, text: name}))
            }
        },
        methods: {
            async submit() {
                let {typeId, content} = this.form
                content = content.trim()
                if (content.length === 0) return

                try {
                    const {status} = await this.$store.dispatch('base/feedback/create', {typeId, content})
                    swal({
                        title: 'Merci pour votre avis',
                        text: 'Nous prenons en compte vos avis afin d\'améliorer l\'application',
                        icon: 'success'
                    });
                    this.$router.go(-1);
                } catch (e) {
                    basicErrorHandler(e)
                }
            }
        }
    }
</script>
